// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    HeartX,
    Heater,
    Helicopter,
    Hexagon,
    Highlighter,
    Hop,
    HopOff,
    Hospital,
    Hotel,
    Hourglass,
    House,
    HouseHeart,
    HousePlug,
    HousePlus,
    HouseWifi,
    IceCreamBowl,
    IceCreamCone,
    IdCard,
    IdCardLanyard,
    Image,
    ImageDown,
    ImageMinus,
    ImageOff,
    ImagePlay,
    ImagePlus,
    ImageUp,
    ImageUpscale,
    Images,
    Import,
    Inbox,
    IndianRupee,
    Infinity as InfinityIcon,
    Info,
    InspectionPanel,
    Italic,
    IterationCcw,
    IterationCw,
    JapaneseYen,
    Joystick,
    Kanban,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "heart-x" through "kanban", inclusive. */
const shard: Record<string, LucideIcon> = {
    "heart-x": HeartX,
    heater: Heater,
    helicopter: Helicopter,
    hexagon: Hexagon,
    highlighter: Highlighter,
    hop: Hop,
    "hop-off": HopOff,
    hospital: Hospital,
    hotel: Hotel,
    hourglass: Hourglass,
    house: House,
    "house-heart": HouseHeart,
    "house-plug": HousePlug,
    "house-plus": HousePlus,
    "house-wifi": HouseWifi,
    "ice-cream-bowl": IceCreamBowl,
    "ice-cream-cone": IceCreamCone,
    "id-card": IdCard,
    "id-card-lanyard": IdCardLanyard,
    image: Image,
    "image-down": ImageDown,
    "image-minus": ImageMinus,
    "image-off": ImageOff,
    "image-play": ImagePlay,
    "image-plus": ImagePlus,
    "image-up": ImageUp,
    "image-upscale": ImageUpscale,
    images: Images,
    import: Import,
    inbox: Inbox,
    "indian-rupee": IndianRupee,
    infinity: InfinityIcon,
    info: Info,
    "inspection-panel": InspectionPanel,
    italic: Italic,
    "iteration-ccw": IterationCcw,
    "iteration-cw": IterationCw,
    "japanese-yen": JapaneseYen,
    joystick: Joystick,
    kanban: Kanban,
};

export default shard;
